import { render, staticRenderFns } from "./ReporteTxPxa.vue?vue&type=template&id=451fca9c&scoped=true"
import script from "./ReporteTxPxa.vue?vue&type=script&lang=js"
export * from "./ReporteTxPxa.vue?vue&type=script&lang=js"
import style0 from "./ReporteTxPxa.vue?vue&type=style&index=0&id=451fca9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451fca9c",
  null
  
)

export default component.exports